"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var WinnersTopListCtl = /** @class */ (function (_super) {
    __extends(WinnersTopListCtl, _super);
    function WinnersTopListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_winner_top_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.winner_top_tag; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_usr_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_id; });
        _this.dk_usr_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_login; });
        _this.dk_app_currency_iso = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_iso; });
        _this.dk_gws_gameprovider_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_id; });
        _this.dk_gws_gameprovider_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_title; });
        _this.dk_gws_gameprovider_game_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_id; });
        _this.dk_gws_gameprovider_game_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_title; });
        _this.dk_win_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_amount; });
        _this.dk_win_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_year; });
        _this.dk_win_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_month; });
        _this.dk_win_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_day; });
        _this.dk_win_hour = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_hour; });
        _this.dk_win_minute = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_minute; });
        _this.dk_win_second = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_second; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_win2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_win2; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    WinnersTopListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    WinnersTopListCtl.prototype.getById = function (key) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                return this.DATA.data[i];
            }
        }
        throw "winner top with (key) -> [" + key + "] not found !";
    };
    WinnersTopListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListWinnersTopByBrandIdGetGet.exec({
            brand_id_list: data.brand_id_list,
            all_brands: data.all_brands,
            all_dates: data.all_dates,
            date_year: data.date_year,
            date_month: data.date_month
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    winner_top_tag: resp.list[i].winner_top_tag,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    gws_gameprovider_id: resp.list[i].gws_gameprovider_id,
                    gws_gameprovider_title: resp.list[i].gws_gameprovider_title,
                    gws_gameprovider_game_id: resp.list[i].gws_gameprovider_game_id,
                    gws_gameprovider_game_title: resp.list[i].gws_gameprovider_game_title,
                    is_locked: resp.list[i].is_locked,
                    win_amount: resp.list[i].win_amount,
                    win_day: resp.list[i].win_day,
                    win_month: resp.list[i].win_month,
                    win_year: resp.list[i].win_year,
                    win_hour: resp.list[i].win_hour,
                    win_minute: resp.list[i].win_minute,
                    win_second: resp.list[i].win_second,
                    date_win2: moment(resp.list[i].date_win_uts_ms).utc(false),
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    app_currency_iso: resp.list[i].app_currency_iso
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    WinnersTopListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddWinnerTop.exec({
            data: {
                winner_top_tag: data.winner_top_tag,
                brand_id: data.brand_id,
                usr_player_id: data.usr_player_id,
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                win_amount: data.win_amount,
                win_day: data.win_day,
                win_month: data.win_month,
                win_year: data.win_year,
                win_hour: data.win_hour,
                win_minute: data.win_minute,
                win_second: data.win_second,
                is_locked: data.is_locked
            }
        }, function (resp) {
            _this.DATA.data.push({
                usr_player_id: data.usr_player_id,
                usr_player_login: resp.player_login,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_win2: moment(resp.date_win_uts_ms).utc(false),
                gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                gws_gameprovider_game_title: resp.gws_gameprovider_game_title,
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_title: resp.gws_gameprovider_title,
                is_locked: data.is_locked,
                win_amount: data.win_amount,
                win_year: data.win_year,
                win_month: data.win_month,
                win_day: data.win_day,
                win_hour: data.win_hour,
                win_minute: data.win_minute,
                win_second: data.win_second,
                winner_top_tag: data.winner_top_tag,
                key: resp.key_uid,
                app_currency_iso: resp.app_currency_iso
            });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    WinnersTopListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditWinnerTop.exec({
                data: {
                    winner_top_id: data.key,
                    winners_top_tag: data.winner_top_tag,
                    usr_player_id: data.usr_player_id,
                    gws_gameprovider_id: data.gws_gameprovider_id,
                    gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                    win_amount: data.win_amount,
                    win_day: data.win_day,
                    win_month: data.win_month,
                    win_year: data.win_year,
                    win_hour: data.win_hour,
                    win_minute: data.win_minute,
                    win_second: data.win_second,
                    is_locked: data.is_locked
                }
            }, function (resp) {
                _tmp.winner_top_tag = data.winner_top_tag;
                _tmp.usr_player_id = data.usr_player_id;
                _tmp.usr_player_login = resp.player_login;
                _tmp.gws_gameprovider_id = data.gws_gameprovider_id;
                _tmp.gws_gameprovider_title = resp.gws_gameprovider_title;
                _tmp.gws_gameprovider_game_id = data.gws_gameprovider_game_id;
                _tmp.gws_gameprovider_game_title = resp.gws_gameprovider_game_title;
                _tmp.win_year = data.win_year;
                _tmp.win_month = data.win_month;
                _tmp.win_day = data.win_day;
                _tmp.win_hour = data.win_hour;
                _tmp.win_minute = data.win_minute;
                _tmp.win_second = data.win_second;
                _tmp.is_locked = data.is_locked;
                _tmp.app_currency_iso = resp.app_currency_iso;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    WinnersTopListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    WinnersTopListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteWinnerTop.exec({ data: { winner_top_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    WinnersTopListCtl.prototype.doSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetWinnerTopIsLocked.exec({
                data: {
                    winner_top_id: key,
                    is_locked: isLocked
                }
            }, function (resp) {
                _tmp.is_locked = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return WinnersTopListCtl;
}(BaseController_1.BaseController));
exports.WinnersTopListCtl = WinnersTopListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_winners_top/ctl/WinnersTopListCtl.ts
// module id = 926
// module chunks = 0